import { Bases26VeContent } from './content/bases-26-ve-content';
import { Bases25Content } from './content/bases-25-content';
import { Bases26ArContent } from './content/bases-26-ar-content';
import { Bases26CoContent } from './content/bases-26-co-content';
import { Bases26MxContent } from './content/bases-26-mx-content';

// One bases page for every edition, with the legal text as per-edition content
// (PORTING.md G5). The Next tree had four `<Bases*Content />` components, each wrapping
// its own copy of this `prose` div; here the wrapper is the single code path and the
// documents — which really are four different contracts, with their own jurisdiction,
// data-protection statute, venue and dates — are the content keyed by slug.
export const BASES_EDITIONS = ['25', '26-ar', '26-co', '26-mx', '26-ve'] as const;

export type BasesEdition = (typeof BASES_EDITIONS)[number];

const DOCUMENTS: Record<BasesEdition, () => React.ReactNode> = {
  '25': Bases25Content,
  '26-ar': Bases26ArContent,
  '26-co': Bases26CoContent,
  '26-ve': Bases26VeContent,
  '26-mx': Bases26MxContent,
};

export function isBasesEdition(slug: string): slug is BasesEdition {
  return (BASES_EDITIONS as readonly string[]).includes(slug);
}

export default function BasesContent({ edition }: { edition: BasesEdition }) {
  const Document = DOCUMENTS[edition];

  return (
    <div className="prose prose-invert max-w-none">
      <Document />
    </div>
  );
}
